import Api from "../../helpers/api";
import Locations from "../../helpers/locations";
import Constants from "./BankConstant";

export const patchFromBankDetails = (body,id,hashid) => {

    const location = `${Locations?.patchBankdetailApi}${id}?hashid=${hashid}`

  return function(dispatch) {
    const successCall = (response) => {
      console.log(response, "<<<");
      dispatch({
          type: Constants.ACTIONS.PATCH_BANK_DETAILS_SUCCESS,
          payload: response
      });
    };

    const errorCall = (errorResponse) => {
      console.log(errorResponse, "<<<<<<---<");
      // dispatch({
      //     type: Constants.ACTIONS.PATCH_BANK_DETAILS_FAILED,
      //     payload: errorResponse
      // });
    };

    Api.doPatch(location, body, successCall, errorCall);
  };
};

export default {
    patchFromBankDetails,
};
